import { Routes } from '@angular/router';
import { CompleteModifyRenewalRoutes } from './complete-modify-renewal/complete-modify-renewal.routing';
import { ShortModifyRenewalRoutes } from './short-modify-renewal/short-modify-renewal.routing';

export const ModifyRenewalRoutes: Routes = [...ShortModifyRenewalRoutes, ...CompleteModifyRenewalRoutes];
